export enum CashSettlementEnum {
  ALL_STATUS = '',
  PROCESSING = 'PROCESSING',
  AWAITING_VERIFICATION = 'AWAITING_VERIFICATION',
  CLOSED = 'CLOSED',
  COMPLETED = 'COMPLETED',
  NO_OUTSTANDING_BALANCE = 'NO_OUTSTANDING_BALANCE',
  AWAITING_TRANSFER = 'AWAITING_TRANSFER',
  NO_DATA = 'NO_DATA',
  AWAITING_CLOSED = 'AWAITING_CLOSED',
  SEND_BACK = 'SEND_BACK'
}

export enum CashSettlementStoreStatusEnum {
  NO_DATA = 'NO_DATA',
  AWAITING_TRANSFER = 'AWAITING_TRANSFER',
  AWAITING_VERIFICATION = 'AWAITING_VERIFICATION',
  SEND_BACK = 'SEND_BACK',
  COMPLETED = 'COMPLETED',
  NO_OUTSTANDING_BALANCE = 'NO_OUTSTANDING_BALANCE'
}

export const cashSettlementStoreStatusList = [
  { value: '', label: 'All Status' },
  { value: 'NO_DATA', label: 'No Data' },
  { value: 'AWAITING_TRANSFER', label: 'Awaiting Transfer' },
  { value: 'AWAITING_VERIFICATION', label: 'Awaiting Verification' },
  { value: 'SEND_BACK', label: 'Send Back' },
  { value: 'COMPLETED', label: 'Completed' },
  { value: 'NO_OUTSTANDING_BALANCE', label: 'No Outstanding Balance' }
];
